const productReviewData=[
    {
        key:1,
        participantName:'No survey yet!!',
        email:'',
        submitDate:'',
        survey:'',
        protoType:'',
    },

]
export default productReviewData;